/**
 * The default set of page size options for pagination components.
 *
 * @remarks
 * These values represent the number of items displayed per page in a paginated view.
 */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
